import { render, staticRenderFns } from "./SmileysSwiper.vue?vue&type=template&id=260f563a&scoped=true&"
import script from "./SmileysSwiper.vue?vue&type=script&lang=js&"
export * from "./SmileysSwiper.vue?vue&type=script&lang=js&"
import style0 from "./SmileysSwiper.vue?vue&type=style&index=0&id=260f563a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260f563a",
  null
  
)

export default component.exports